export default __webpack_public_path__ + "static/media/Hangman5.f9362ace.svg";